import { useDispatch, useSelector } from "react-redux";
import {
  addBotConversation,
  addUserConversation,
} from "../actions/conversationAction";
import { IRootState } from "../store";
import { IConversation } from "../types/conversationTypes";

export default function useConversationProvider() {
  const dispatch = useDispatch();

  const conversationList = useSelector<IRootState, IConversation[]>(
    (state) => state.conversation
  );

  const addUserMessage = (prompt: string) => {
    dispatch(addUserConversation(prompt));
  };

  const addBotMessage = (message: string) => {
    dispatch(addBotConversation(message));
  };

  return { conversationList, addUserMessage, addBotMessage };
}
